/* src/app/component/promotion-dashboard/promotion-dashboard.component.scss */
.dashboard-container {
  padding: 20px;
  margin-left: 250px;
}
.dashboard-heading {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
  padding: 12px 0;
  font-size: 24px;
  font-weight: 600;
  margin: 0px;
  margin-bottom: 24px;
}
.filter {
  margin-bottom: 30px;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
@media (max-width: 1100px) {
  .card-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .card-grid {
    grid-template-columns: 1fr;
  }
}
.promo-card {
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.card-image {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f8f8;
  position: relative;
}
.pdf-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: #f8f8f8;
}
.pdf-icon {
  font-size: 64px;
  color: #d32f2f;
}
.card-content {
  padding: 16px;
  display: flex;
}
.card-content p {
  margin: 6px 0px;
  font-size: 16px;
}
.promo-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #000;
  margin-top: 15px;
}
.promo-description {
  font-size: 14px;
  color: #555;
  margin-bottom: 10px;
}
.preview-link {
  display: inline-block;
  color: #1a73e8;
  text-decoration: underline;
  margin-bottom: 12px;
}
.actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}
.full-image-preview {
  width: 100%;
  max-height: 600px;
  object-fit: contain;
}
textarea {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.02);
  border-radius: 8px;
  width: 100%;
  padding: 10px 14px;
  font-feature-settings: var(--font-feature-settings, normal);
  font-size: 1rem;
  color: #4b5563;
  background: #ffffff;
  border: 1px solid #d1d5db;
  transition:
    background-color 0.2s,
    color 0.2s,
    border-color 0.2s,
    box-shadow 0.2s;
  appearance: none;
}
textarea:focus {
  border: 1px solid #FFC680 !important;
  border-color: #FFC680 !important;
  outline: none;
}
::ng-deep .p-tabview .p-tabview-nav {
  background: transparent;
  border: none;
  border-bottom: 1px solid #E4E7EC !important;
}
::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
  background: transparent !important;
  color: #6B7280;
  padding: 0px 4px 16px 4px;
  font-weight: 600;
  margin-right: 20px;
  position: relative;
  font-size: 14px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #D47500 !important;
  border: none !important;
  margin-bottom: 0px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2.8px;
  background: #D47500;
}
::ng-deep .p-tabview .p-tabview-panels {
  background: transparent;
  padding: 24px 0 0 0;
  border: none;
}
::ng-deep .p-tabview .p-tabview-nav-content {
  border: none !important;
}
.load-more-wrapper {
  text-align: center;
  margin-top: 20px;
}
::ng-deep .btn-secondary {
  background: #f0f0f0;
  border: 1px solid #ccc;
  color: #333;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}
::ng-deep .btn-secondary:hover {
  background: #e2e2e2;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}
:host ::ng-deep input {
  height: 36px !important;
}
.danger1 {
  background: #ffffff;
  border: 1px solid #ef4444;
}
.btn {
  height: 40px !important;
  font-size: 14px;
}
.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(104, 103, 96, 0.4);
}
:host ::ng-deep .p-button-label {
  color: #000;
}
:host ::ng-deep .p-datepicker {
  transform-origin: top center !important;
  top: unset !important;
  bottom: auto !important;
  left: -100px !important;
  margin-top: 40px !important;
}
@media screen and (max-width: 1200px) {
  :host ::ng-deep .p-datepicker {
    transform-origin: top center !important;
    top: unset !important;
    bottom: auto !important;
    left: -160px !important;
    margin-top: 40px !important;
  }
}
/*# sourceMappingURL=promotion-dashboard.component-CXWOH4BU.css.map */
